enum treatmentCertification {
  NOT_TREATED = 'not_treated',
  DAWR = 'dawr',
  ISPM = 'ispm',
}
export default treatmentCertification;
